// @ts-nocheck
import React, { useEffect, useState } from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import { Delete as DeleteIconRed, Edit as EditIcon } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import InformacionAlias from './InformacionAlias';
import Paginador from './Componentes/Paginador';
import usePagination from '../Componentes/usePagination';
import { ALIASES_PER_PAGE } from '../Contantes/Constantes';
import Tooltip from '@mui/material/Tooltip';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useAlias } from './State/AliasContext';
import KeyCloak from '../Auth/Keycloak';
import { styled } from '@mui/material/styles';

const Root = styled('div')({
    width: '100%',
    maxWidth: '100%',
    borderRadius: '30px',
});

const Izquierda = styled('div')({
    display: 'flex',
    justifyContent: 'flex-start',
});

export default function ListaAlias(props) {
    const { alias, setAlias, aliases, setAliases } = props;
    const { setOpenEditar, setOpenVista, setOpenEliminar, fetchAreas } = useAlias();
    const { pageCount, paginateAliases } = usePagination(aliases, ALIASES_PER_PAGE);
    const [currentPage, setCurrentPage] = useState(1);
    const [aliasesForDisplay, setAliasesForDisplay] = useState(paginateAliases(aliases, currentPage));
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('lg'));

    useEffect(() => {
        setAliasesForDisplay(paginateAliases(aliases, currentPage));
    }, [currentPage, aliases]);

    const handleClickEditar = (alias) => {
        setAlias(alias);
        setOpenEditar(true);
        fetchAreas();
    };

    const abrirEliminar = (alias) => {
        setAlias(alias);
        setOpenEliminar(true);
    };

    return (
        <>
            <List>
                {aliasesForDisplay.map((unAlias, index) => (
                    <React.Fragment key={index}>
                        <ListItem
                            sx={{
                                borderRadius: '30px',
                                cursor: 'pointer',
                                '&:hover': {
                                    backgroundColor: '#f0f0f0',
                                },
                            }}
                            alignItems="flex-start"
                        >
                            <InformacionAlias style={{ width: '100%' }} matches={matches} aliase={unAlias} />
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                {KeyCloak.hasRole(['ROLE_MODIFICAR_ALIAS']) && (
                                    <Tooltip title="Editar alias">
                                        <IconButton
                                            aria-label="Editar alias"
                                            onClick={() => handleClickEditar(unAlias)}
                                            size="large"
                                        >
                                            <EditIcon fontSize={matches ? 'small' : 'inherit'} color="primary" />
                                        </IconButton>
                                    </Tooltip>
                                )}
                                {KeyCloak.hasRole(['ROLE_ELIMINAR_ALIAS']) && (
                                    <Tooltip title="Eliminar alias">
                                        <IconButton
                                            onClick={() => abrirEliminar(unAlias)}
                                            size="large"
                                        >
                                            <DeleteIconRed sx={{ color: "red" }} />
                                        </IconButton>
                                    </Tooltip>
                                )}
                            </div>
                        </ListItem>
                        <br />
                    </React.Fragment>
                ))}
            </List>
            <Divider />
            <br />
            <Izquierda>
                <Paginador
                    aliasesCount={aliases.length}
                    pageCount={pageCount}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                />
            </Izquierda>
        </>
    );
}
